import axios from 'axios'
import { DAYSJOBSSTATUS } from "@/config/globalVar.js"

let isLoading = false; // Variable de chargement globale

// Fonction pour mettre à jour l'état global du chargement
const setLoadingState = (state) => {
  isLoading = state;
};

const getLoadingState = () => {
  return isLoading;
};


async function getKiosks(isPopulated = false) {

  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosks?isPopulated=' + isPopulated,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
  };

  try {
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

// async function getLogMonoCase() {
//   var config = {
//     method: 'get',
//     url: process.env.VUE_APP_API_EXT_URL + '/logmonocase/',
//     headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
//   };

//   try {
//     console.log("request ================= ");
//     let res = await axios(config)
//     return res.data;
//   } catch (error) {
//     setLoadingState(false);  
//     return null;
//   } finally {
//     setLoadingState(false);  
//   }
// }
/*async function getLogMonoCaseByPagination(page, limit, filter) {
  var data = JSON.stringify({ "page": page, "limit": limit, "filter": filter });

  var config = {
    method: 'post',
    url: process.env.VUE_APP_API_EXT_URL + '/logmonocase/pagination',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json' },
    data: data
  };

  try {
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);
    return null;
  } finally {
    setLoadingState(false);
  }
}*/

async function getLogMonoCaseByPagination(page, limit, filter, sortBy = null, sortDesc = false) {
  var data = JSON.stringify({ 
    page, 
    limit, 
    filter, 
    sortBy, 
    sortDesc 
  });

  var config = {
    method: 'post',
    url: process.env.VUE_APP_API_EXT_URL + '/logmonocase/pagination',
    headers: { 
      Authorization: 'Bearer ' + localStorage.getItem('jwt'), 
      'Content-Type': 'application/json' 
    },
    data: data
  };

  try {
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);
    return null;
  } finally {
    setLoadingState(false);
  }
}

async function getLogEnergyCardByPagination(page, limit, filter, sortBy = null, sortDesc = false) {
  var data = JSON.stringify({ 
    page, 
    limit, 
    filter, 
    sortBy, 
    sortDesc 
  });

  var config = {
    method: 'post',
    url: process.env.VUE_APP_API_EXT_URL + '/logEnergyCard/energy-card/pagination',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json' },
    data: data
  };

  try {
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);
    return null;
  } finally {
    setLoadingState(false);
  }
}


async function getKiosksNames() {
  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosks/namesKiosks' ,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') },
  };
  try {
    let res = await axios(config)
    return res.data;
  } catch (error) {
    return null;
  }
}

async function getKiosksWithoutAllJobs(isPopulated = false) {
  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosks/minimJobs?isPopulated=' + isPopulated,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), daysjobsstatus: DAYSJOBSSTATUS }
  };

  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    //console.log("RequestServices -> getKiosks -> res => ", res)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

async function getKiosksListAsked(listKioks) {

  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosks/KiosksList',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), listkioksname: listKioks}
  };

  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    //console.log("RequestServices -> getKiosks -> res => ", res)

    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

async function getJobsForKiosk(params) {
    const config = {
        method: 'get',
        url: process.env.VUE_APP_API_EXT_URL + '/job/findJobs',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') },
        params,
        paramsSerializer: (params) =>{
          const qs = require('qs');
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
    };

    try {
        setLoadingState(true);
        const res = await axios(config);
        return res.data;
    } catch (error) {
        return [];
    } finally {
        setLoadingState(false);
    }
}

async function getKiosksCheckHistory(listKioks) {

  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosks/KiosksCheckHistory',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), listkioksname: listKioks}
  };

  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    //console.log("RequestServices -> getKiosks -> res => ", res)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

async function getKioskByName(kioskName, isPopulated = false) {

  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosk/' + kioskName + '?isPopulated=' + isPopulated,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt')},
  };

  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    //console.log("RequestServices -> getKioskByName -> res => ", res)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}


async function sendDatasAtPathForKiosks(data, path, kiosks) {
  if (kiosks.length === 1) {
    try {
      const response = await sendDatasAtPath(data, path + kiosks[0]);
      const ok = response.status === 200;
      return { succ: ok ? 1 : 0, err: ok ? 0 : 1, total: 1 };
    } catch (error) {
      console.error('sendDatasAtPathForKiosks (single kiosk) error:', error);
      return { succ: 0, err: 1, total: 1 };
    }
  }

  const jobType = path.split('/').filter(Boolean)[1]; // Extract job type from path
  return await sendBulkDataForKiosks(data, jobType, kiosks);
}

async function sendBulkDataForKiosks(data, jobType, kiosks) {
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_EXT_URL}/job/${jobType}/bulk`,
      { ...data, kioskNames: kiosks },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') },
      }
    );
    if (response.status === 200) {
      const created = response.data.created || 0;
      const missingKiosks = response.data.missingKiosks || [];
      return { succ: created, err: missingKiosks.length, total: kiosks.length, missingKiosks };
    }
    return { succ: 0, err: kiosks.length, total: kiosks.length };
  } catch (error) {
    console.error('sendBulkDataForKiosks error:', error);
    return { succ: 0, err: kiosks.length, total: kiosks.length };
  }
}



function sendDatasAtPath(data, path) {

  return axios
    .post(process.env.VUE_APP_API_EXT_URL + path, data, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
    });
}


async function getResFromJob(jobId) {

  return new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_EXT_URL + '/job/getRes/' + jobId, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then((doc) => {

        resolve(doc);
        setLoadingState(false);  // Active l'état de chargement
      })
      .catch((error) => {
        setLoadingState(false);  // Active l'état de chargement

        reject(error)

      });
  });
}


async function verifyIfUserIsAdmin() {
  setLoadingState(true);  // Active l'état de chargement

  return new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_EXT_URL.split('API_EXT')[0] + 'auth/API_EXT/hasadminrights', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then((doc) => {
        resolve(doc.data.isAdmin);
        setLoadingState(false);  // Active l'état de chargement


      })
      .catch((error) => {
        setLoadingState(false);  // Active l'état de chargement
        reject(error)

      });
  });
}


async function getUsers() {

  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/users',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
  };

  let res = await axios(config)
  return res.data;
}


async function createUser(username, password, role){

  var data = JSON.stringify({"password":password,"role":role});
  var config = {
    method: 'post',
    url: process.env.VUE_APP_API_EXT_URL + '/user/'+username,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json' }, 
    data : data
  };

  let res = await axios(config)
  return res.data;
}

async function updateLastJobInKioskTable(kioskName, item) {
  var data = JSON.stringify({ date: item.updatedAt, type: item.__t, state: item.state })
  var config = {
    method: 'put',
    url: process.env.VUE_APP_API_EXT_URL + "/kiosk/updateJob/" + kioskName,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json'},
    data: data
  };
  let res = await axios(config)
  return res.data
}


async function updateEtat(name, etat){

  var data = JSON.stringify({"name":name,"etat":etat});
  var config = {
    method: 'post',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosk/'+name,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json' }, 
    data : data
  };



  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

async function deleteUser(username){


  var config = {
    method: 'delete',
    url: process.env.VUE_APP_API_EXT_URL + '/user/'+username,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'),}, 
  
  };

  try {
    setLoadingState(true);  // Active l'état de chargement

    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement

    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}

async function updateUser(user) {
  var config = {
    method: "put",
    url: process.env.VUE_APP_API_EXT_URL + "/user/update",
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), 'Content-Type': 'application/json'},
    data: { login: user.login, role: user.role }
  };
  let res = await axios(config)
  return res.data;
}

async function deleteKiosk(kioskName){


  var config = {
    method: 'delete',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosk/'+kioskName,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'),}, 
  
  };

  try {
    setLoadingState(true);  // Active l'état de chargement

    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement

    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement

  }
}

async function deleteJob(item) {
  var config = {
    method: "delete",
    url: process.env.VUE_APP_API_EXT_URL + "/job/" + item._id + "/" + item.ownerKiosk,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt'), },
  };
  try {
    setLoadingState(true);  // Active l'état de chargement
    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement
    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement
  }
}


async function getLastJob(kioskName){


  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/job//'+ kioskName,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
  };

  try {
    setLoadingState(true);  // Active l'état de chargement

    let res = await axios(config)
    return res.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement

    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement

  }

}
async function getListLastJobs() {


  const config = {
    method: "get",
    url: `${process.env.VUE_APP_API_EXT_URL}/job/jobs/list`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    },
  };

  try {
    setLoadingState(true);  // Active l'état de chargement

    const response = await axios(config);
    
    return response.data;
  } catch (error) {
    setLoadingState(false);  // Active l'état de chargement

    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement

  }
}
async function getLastAutoDiagJobs() {
  const config = {
    method: "get",
    url: `${process.env.VUE_APP_API_EXT_URL}/job/jobs/getLastAutoDiagForEachKiosk`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    },
  };

  try {
    setLoadingState(true);  // Active l'état de chargement

    const response = await axios(config);    
    return response.data;
  } catch (error) { 
    setLoadingState(false);  // Active l'état de chargement

    return null;
  } finally {
    setLoadingState(false);  // Active l'état de chargement

  }
}

async function getListFilesNameInDirectory(nameKiosk){
  
  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosk/getFilesName/'+ nameKiosk,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
  };
  
  let res = await axios(config)
 
  return res.data;


}

async function getListSQLFilesNameInDirectory(nameKiosk){
  
  var config = {
    method: 'get',
    url: process.env.VUE_APP_API_EXT_URL + '/kiosk/getSQLFilesName/'+ nameKiosk,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
  };
  
  let res = await axios(config)
 
  return res.data;


}

async function getListFilesInDirectory(nameKiosk){
  return new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_EXT_URL + '/kiosk/getFiles/'+ nameKiosk, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
      })
      .then((doc) => {
        resolve(doc);

      })
      .catch((error) => {
        reject(error)

      });
    });
}

export {
  setLoadingState,
  getKiosks,
  getKiosksWithoutAllJobs,
  getKiosksListAsked,
  sendDatasAtPathForKiosks,
  getKiosksCheckHistory,
  getResFromJob,
  getKioskByName,
  verifyIfUserIsAdmin,
  getUsers,
  createUser,
  deleteUser,
  updateUser,
  deleteKiosk,
  deleteJob,
  updateLastJobInKioskTable,
  updateEtat,
  getLastJob,
  getListLastJobs,
  getListFilesInDirectory,
  getListFilesNameInDirectory,
  getListSQLFilesNameInDirectory,
  getLastAutoDiagJobs,
  getLogMonoCaseByPagination,
  getKiosksNames,
  getLoadingState,
  getLogEnergyCardByPagination,
  getJobsForKiosk
}